import { Box, BoxProps, CardProps, Typography } from "@mui/material";
import { ChipCellWithCircle } from "@pimo/pimo-components";
import { FC } from "react";

export interface AintStatusesCellProps {
  /** cell header */
  header?: string;
  statuses: {
    textColor: string;
    chipColor: string;
    value: string;
    label: string;
  }[];
  /** Additional MUI styling */
  cardProps?: CardProps;
  /** Additional header styling */
  headerProps?: BoxProps;
  /** chip props */
  chipProps?: BoxProps;

  //isHidden not used in here used to hide sells in the pimo table
  isHidden?: boolean;
}

/** Chip Card with title and body for the cells that need to display a header with a chip beneath it */
export const AintStatusesCell: FC<AintStatusesCellProps> = ({ statuses }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 0.5,
      }}
    >
      {statuses.map((status, index) => (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",

            alignItems: "center",
            justifyContent: "center",
            minWidth: "55px",
            maxWidth: "55px",
            gap: 0.5,
          }}
        >
          <Box
            key={index}
            sx={{
              textAlign: "center",
              fontSize: "12px",
              height: "20px",
              lineHeight: "20px",
              py: "auto",
              px: "1.5em",
              borderRadius: "5px",
              fontWeight: 500,
              color: status.textColor,
              backgroundColor: status.chipColor,
              minWidth: "50px",
            }}
          >
            {status.value}
          </Box>
          <Typography
            sx={{ minWidth: "60px", textAlign: "center" }}
            variant="body2"
          >
            {status.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default ChipCellWithCircle;
